export default __webpack_public_path__ + "static/media/400.07bba8f6.woff";